(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mj-bundle-rewards"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mj-bundle-rewards')) {
    customElements.define('mj-bundle-rewards', class extends HTMLElement {
      connectedCallback() {
        this.root = document.getElementById('MainProduct-' + this.dataset.section) || this.closest('.shopify-section');
        if (!this.root) return;
        this.cards = Array.from(this.querySelectorAll('[data-tier]'));
        this.addon = this.querySelector('[data-mj-addon]');
        this.summary = this.querySelector('.mj-rewards-summary');
        this.form = this.root.querySelector('product-form form');
        this.submit = event => this.addSelectedOffer(event);
        this.form?.addEventListener('submit', this.submit, true);
        this.addon.checked = false;
        this.resetAddon = () => { this.addon.checked = false; this.update(false); };
        window.addEventListener('pageshow', this.resetAddon);
        this.timers = [];
        this.change = () => this.update(true);
        this.root.addEventListener('change', this.change);
        this.update(false);
      }
      async addSelectedOffer(event) {
        if (!this.addon.checked || this.addon.disabled) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.pending) return;
        const formData = new FormData(this.form);
        const parentId = Number(formData.get('id'));
        const quantity = Number(this.root.querySelector('quantity-breaks input[type="radio"]:checked')?.value || formData.get('quantity') || 1);
        if (!Number.isSafeInteger(parentId) || !Number.isSafeInteger(quantity) || quantity < 1) return;
        const properties = {};
        for (const [key,value] of formData.entries()) {
          const property = key.match(/^properties\[(.+)\]$/);
          if (property && typeof value === 'string') properties[property[1]] = value;
        }
        const button = this.form.querySelector('[name="add"]');
        const error = this.querySelector('.mj-addon-error');
        error.hidden = true;
        this.pending = true;
        if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
        try {
          const response = await fetch(this.dataset.addUrl + '.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [
              { id: parentId, quantity, properties },
              { id: Number(this.dataset.addonId), quantity: 1, parent_id: parentId }
            ] })
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
          window.location.assign(this.dataset.cartUrl);
        } catch (failure) {
          error.textContent = failure.message || this.dataset.error;
          error.hidden = false;
          this.pending = false;
          if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
        }
      }
      update(animate) {
        this.timers.forEach(clearTimeout);
        this.timers = [];
        const quantity = Number(this.root.querySelector('quantity-breaks input[type="radio"]:checked')?.value || 2);
        let stagger = 0;
        this.cards.forEach(card => {
          const unlocked = quantity >= Number(card.dataset.tier);
          const wasUnlocked = card.classList.contains('is-unlocked');
          card.classList.remove('is-opening');
          if (unlocked && !wasUnlocked && animate && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
            const delay = stagger++ * 160;
            this.timers.push(setTimeout(() => {
              card.classList.add('is-opening', 'is-unlocked');
              this.timers.push(setTimeout(() => card.classList.remove('is-opening'), 1000));
            }, delay));
          } else card.classList.toggle('is-unlocked', unlocked);
        });
        const summary = quantity >= 3 ? this.dataset.summaryThree : quantity >= 2 ? this.dataset.summaryTwo : this.dataset.summaryOne;
        if (this.summary.textContent !== summary) this.summary.textContent = summary;
        this.totalCents = (quantity >= 3 ? 8367 + (quantity - 3) * 2999 : quantity === 2 ? 5758 : 2999) + (this.addon.checked ? 1499 : 0);
        this.root.dispatchEvent(new CustomEvent('mj:offer-change', {bubbles:true}));
      }
      disconnectedCallback() {
        this.root?.removeEventListener('change', this.change);
        this.form?.removeEventListener('submit', this.submit, true);
        window.removeEventListener('pageshow', this.resetAddon);
        this.timers?.forEach(clearTimeout);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mj-preorder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mj-preorder')) {
    customElements.define('mj-preorder', class extends HTMLElement {
      connectedCallback() {
        this.root = document.getElementById('MainProduct-' + this.dataset.section) || this.closest('.shopify-section');
        if (!this.root) return;
        this.update = () => {
          const selected = this.root.querySelector('quantity-breaks input[type="radio"]:checked');
          const option = selected && this.root.querySelector('label[for="' + selected.id + '"]');
          const price = option && option.querySelector('.quantity-break__price');
          const offer = this.root.querySelector('mj-bundle-rewards');
          const amount = offer && Number.isFinite(offer.totalCents) ? new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:offer.dataset.currency || 'USD'}).format(offer.totalCents / 100) : (price ? price.textContent.trim() : this.dataset.initialPrice);
          const label = this.dataset.label.replace('__AMOUNT__', amount);
          this.root.querySelectorAll('.main-atc__label__text, .sticky-atc__label__text').forEach(element => {
            const button = element.closest('button');
            if (button && button.dataset.unavailable !== 'true' && element.textContent.trim() !== label) element.textContent = label;
          });
        };
        this.root.addEventListener('change', this.update);
        this.root.addEventListener('mj:offer-change', this.update);
        this.observer = new MutationObserver(this.update);
        this.observer.observe(this.root, {subtree: true, childList: true, characterData: true});
        this.update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.root?.removeEventListener('change', this.update);
        this.root?.removeEventListener('mj:offer-change', this.update);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
